import { generateAssetsContextValue } from '@gaming1/g1-core-web';
import { PaymentAssetsContext } from '@gaming1/g1-payment-web';

import bonusBackground from './bonus/image_1.jpg';

export const paymentAssets = generateAssetsContextValue(PaymentAssetsContext)({
  /* Bonus */
  bonusBackground,
});
